import '../../../../packages/neb-lit-components/src/components/neb-text';
import '../../../../packages/neb-lit-components/src/components/neb-button';

import { html, css } from 'lit';

import NebTable, {
  ELEMENTS as BASE_ELEMENTS,
} from '../../../../packages/neb-lit-components/src/components/tables/neb-table';
import { parseDate } from '../../../../packages/neb-utils/date-util';
import { centsToCurrency } from '../../../../packages/neb-utils/formatters';

export const ELEMENTS = {
  ...BASE_ELEMENTS,
  paymentDates: { selector: '[id^=payment-date-]' },
  statuses: { selector: '[id^=status-]' },
  amounts: { selector: '[id^=amount-]' },
  viewReceiptButtons: { selector: '[id^=view-receipt-button-]' },
  officeReceiptText: { selector: '[id^=office-receipt-text-]' },
};

const CONFIG = [
  {
    key: 'transactionDate',
    label: 'Payment Date',
    flex: css`1.2 0 0`,
    mobile: true,
    formatter: value => (value ? parseDate(value).format('MMMM DD, YYYY') : ''),
  },
  {
    key: 'status',
    label: 'Status',
    flex: css`1 0 0`,
    mobile: true,
  },
  {
    key: 'amount',
    label: 'Payment Amount',
    flex: css`1 0 0`,
    mobile: true,
    formatter: amount => (amount ? centsToCurrency(amount) : '$0.00'),
  },
  {
    key: 'viewButton',
    label: '',
    flex: css`1 0 0`,
  },
];
class NebTableReceipts extends NebTable {
  constructor() {
    super();
    this.__initHandlers();
    this.config = CONFIG;
  }

  __initHandlers() {
    this.handlers = {
      ...this.handlers,
      clickView: ({ name }) => {
        const rowIndex = name.split('-')[3].split('.')[0];
        return this.onSelectRow(this.name, this.model[rowIndex], rowIndex);
      },
    };
  }

  static get styles() {
    return [
      ...super.styles,
      css`
        .data-cell {
          display: flex;
          flex-direction: column;
        }

        .button-receipt {
          flex: 1 0 0;
          width: max-content;
        }

        .button-container {
          width: 100%;
          display: flex;
          justify-content: flex-end;
        }
      `,
    ];
  }

  renderDataCell(value, columnConfig, rowIndex, name, _error) {
    switch (columnConfig.key) {
      case 'start':
        return html`
          <div class="data-cell">
            <neb-text id="payment-date-${rowIndex}" bold>
              ${parseDate(value).format('MMMM DD, YYYY')} </neb-text
            ><neb-text id="payment-time-${rowIndex}">
              ${parseDate(value).format('h:mm A')}
            </neb-text>
          </div>
        `;

      case 'viewButton':
        return !this.model[rowIndex].parentPaymentId
          ? html`
              <div class="button-container">
                <neb-button
                  id="view-receipt-button-${rowIndex}"
                  label="View"
                  name="view-receipt-button-${name}"
                  .onClick="${this.handlers.clickView}"
                ></neb-button>
              </div>
            `
          : html`
              <neb-text id="office-receipt-text-${rowIndex}" italic>
                Call Office for Receipt
              </neb-text>
            `;

      default:
        return super.renderDataCell(value, columnConfig);
    }
  }
}

customElements.define('neb-table-receipts', NebTableReceipts);
